import fields from './fields';

export default {
  fields,
};



// WEBPACK FOOTER //
// ./src/app/services/form/index.js